import {
  METRIC_CONVERSIONS,
  UNIT_BOX,
  UNIT_DOZEN,
  UNIT_G,
  UNIT_KG,
  UNIT_L,
  UNIT_ML,
  UNIT_PACKET,
  UNIT_PIECE,
} from "./common";
import type { PackDef } from "./types";

export const RETAIL_PACK: PackDef = {
  id: "retail",
  version: 1,
  available: true,
  name: { en: "Grocery & retail", bn: "মুদি ও খুচরা দোকান" },
  description: {
    en: "Grocery, departmental and general stores",
    bn: "মুদি, ডিপার্টমেন্টাল ও সাধারণ দোকান",
  },
  icon: "shopping-basket",
  modules: {
    variants: true,
    batches: false,
    expiry: false,
    serials: false,
    vat: false,
    multi_branch: false,
    storefront: false,
    loans: false,
  },
  baseUnits: [UNIT_PIECE, UNIT_KG, UNIT_G, UNIT_L, UNIT_ML, UNIT_DOZEN, UNIT_PACKET, UNIT_BOX],
  unitConversions: METRIC_CONVERSIONS,
  categories: [
    { en: "Rice & grains", bn: "চাল ও শস্য" },
    { en: "Lentils", bn: "ডাল" },
    { en: "Flour", bn: "আটা ও ময়দা" },
    { en: "Oil & ghee", bn: "তেল ও ঘি" },
    { en: "Spices", bn: "মসলা" },
    { en: "Sugar & salt", bn: "চিনি ও লবণ" },
    { en: "Dairy", bn: "দুগ্ধজাত পণ্য" },
    { en: "Beverages", bn: "পানীয়" },
    { en: "Snacks", bn: "স্ন্যাকস" },
    { en: "Personal care", bn: "ব্যক্তিগত যত্ন" },
    { en: "Household cleaning", bn: "গৃহস্থালি পরিষ্কার" },
    { en: "Baby care", bn: "শিশু যত্ন" },
    { en: "Stationery", bn: "স্টেশনারি" },
  ],
  customFields: [],
  receiptTemplate: "retail",
  dashboard: [
    "sales_today",
    "gross_profit",
    "cash_in_hand",
    "dues_receivable",
    "dues_payable",
    "low_stock",
    "sales_trend",
  ],
};
